import React from 'react';

import { CapaQuotationChatMessageRfq } from '@generated/graphql';

import { CustomizedTypography } from '@components/Customized';

import { Divider } from '@material-ui/core';
import { CheckCircleOutline } from '@material-ui/icons';

interface Props {
  data?: CapaQuotationChatMessageRfq;
}

const CompleteBubble: React.FC<Props> = ({ data }) => {
  const projectName = data?.rfq?.projectName ?? undefined;

  return (
    <div className="message-container">
      <Divider className="message-divider" />
      <CheckCircleOutline className="checkCircleIcon" fontSize="small" />
      <CustomizedTypography
        variant="body2"
        color="textPrimary"
        fontWeight="bold"
      >
        {projectName ?? ''}이&nbsp;
      </CustomizedTypography>
      <CustomizedTypography variant="body2" color="textPrimary">
        거래완료 처리되었습니다.
      </CustomizedTypography>
      <Divider className="message-divider" />
    </div>
  );
};

export default CompleteBubble;
